module.exports = __webpack_public_path__ + "img/Header-left.00129016.jpg";